import { render } from "./AppColorPicker.vue?vue&type=template&id=4075da1c&scoped=true&ts=true"
import script from "./AppColorPicker.vue?vue&type=script&lang=ts"
export * from "./AppColorPicker.vue?vue&type=script&lang=ts"

import "./AppColorPicker.vue?vue&type=style&index=0&id=4075da1c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4075da1c"]])

export default __exports__